import { registerComponent, triggerEvent } from "helpers";
import { WYATTDialog } from "wyatt";

registerComponent(
  "wyatt-drawer",
  class WyattDrawer extends WYATTDialog {
    constructor() {
      super();

      // Listen for addToCart events to scroll to top
      if (this.config.openOn && this.config.openOn.includes("addToCart")) {
        this.subscribe(WYATT.config.pubsub.events.addToCart, () => {
          this.scrollToTop();
        });
      }
    }

    scrollToTop() {
      // Add smooth scroll to top whenever addToCart event happens
      requestAnimationFrame(() => {
        const drawerBody = this.dialog.querySelector(".drawer__body");
        if (drawerBody) {
          drawerBody.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      });
    }

    open() {
      super.open();
      triggerEvent(this.dialog, "drawerOpen");
    }

    close() {
      super.close();
      triggerEvent(this.dialog, "drawerClose");
    }
  }
);
